import { equalJson } from '@dte/otw-utils-core/src/objects/equalJson';
import { useCallback, useEffect, useRef, useState } from 'react';

export function useJsonEqualState<T>(initialValue?: T): [T, (value: T) => void] {
	// Track changes in the input
	const [value, setValue] = useState<T>(initialValue);
	const previousValue = useRef<T>(initialValue);

	// Ensure that the output remains stable
	const setValueIfDifferent = useCallback((newValue: T) => {
		// Value hasn't changed
		if (equalJson(previousValue.current, newValue)) {
			return;
		}

		// Update the value
		previousValue.current = newValue;
		setValue(newValue);
	}, []);

	return [value, setValueIfDifferent];
}

// Use a value that only changes if the json equality changes
export function useJsonEqualValue<T>(currentValue: T): T {
	const [value, setValue] = useJsonEqualState(currentValue);

	useEffect(() => {
		setValue(currentValue);
	}, [currentValue, setValue]);

	return value;
}
